import { mq } from '@styles/vars/media-queries.style'
import { colors } from '@styles/vars/colors.style'
import { clamp } from '@styles/utils/conversion.style'
import {
  getCustomTextStyle,
  textStylesConfig,
} from '@styles/vars/textStyles.style'
import styled from 'styled-components'
import { font } from '@styles/vars/font.style'

export const SubServicesMain = styled.section`
  color: ${props => props.color};
  background-color: ${props => props.background};
`
export const SubServicesTitle = styled.h2`
  ${getCustomTextStyle(textStylesConfig.heading3Sans, textStylesConfig.heading2Serif)}
  ${mq.tabletPMax} {
    font-size: 28px;
  }
`

export const SubServiceItemContainer = styled.div`
  display: block;
  border-bottom: 1px solid ${colors.charcoal};
  .link {
      display: flex;
      align-items: center;
      text-decoration: none;
  }
`

export const SubServiceItemTitle = styled.div`
  padding: 25px 0;
  margin-right: auto;
  flex: 1;
  ${clamp('font-size', 18,  32)};
  font-family: ${font.sans.family};
  font-weight: ${font.sans.weight.extrabold};
`

export const SubServiceItemIcon = styled.div`
  width: 20px;
  height: 20px;
  justify-content: flex-end;
  display: flex;
`
